<div class="progress-dialog">
  <h1 mat-dialog-title class="progress-title">{{ title }}</h1>

  <mat-dialog-content>
    @if (timingStatus) {
      <div class="progress-status">
        <span class="status-text">{{ timingStatus.currentPerc }} of {{ timingStatus.fullAmount }} completed</span>
        <span class="status-percent">{{ timingStatus.percentComplete | number:'1.0-0' }}%</span>
      </div>
      <div class="progress-bar-wrapper">
        <mat-progress-bar mode="determinate" [value]="timingStatus.percentComplete"></mat-progress-bar>
      </div>
    }

    @if (!timingStatus) {
      <div class="progress-status">
        <span class="status-text">Processing...</span>
      </div>
      <div class="progress-bar-wrapper">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      </div>
    }
  </mat-dialog-content>
</div>